// Header.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const Header = ({ toggleSidebar, isSidebarVisible }) => {
  return (
    <header style={headerStyle(isSidebarVisible)}>
      <button style={buttonStyle} onClick={toggleSidebar}>
        <FontAwesomeIcon icon={faBars} style={{ color: '#000' }} /> {/* Set icon color */}
      </button>
      <div style={logoContainerStyle}>
        <Link to='/'>
          <img src="logohome.png" alt="Logo" style={logoStyle} />
        </Link>
      </div>
    </header>
  );
};

const headerStyle = (isSidebarVisible) => ({
  width: '100%',
  height: '80px',
  // backgroundColor: 'rgb(255 142 142)', // Dark Blue
  backgroundColor: '#fff', // Dark Blue
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  display: 'flex',
  alignItems: 'center',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 1000,
  paddingLeft: isSidebarVisible ? '250px' : '0', // Adjust padding based on sidebar visibility
  transition: 'padding-left 0.3s ease',
});

const buttonStyle = {
  backgroundColor: 'transparent', // Change to transparent to match header
  border: 'none',
  fontSize: '24px',
  cursor: 'pointer',
  marginLeft: '10px', // Ensure it doesn't overlap with sidebar
  zIndex: 1002, // Make sure it's above the sidebar
};

const logoContainerStyle = {
  flex: 1,
  display: 'flex',
  justifyContent: 'center', // Center the logo
};

const logoStyle = {
  height: '60px',
};

export default Header;
